export const categoryInfo = {
    "womens_empowerment": {
        title: "Women's Empowerment",
        color: "#E91E63",
        image: "/women-development.jpg",
        description: "PSGS empowers marginalized women through the formation and strengthening of Self-Help Groups (SHGs), skills development training, agro-livelihood support, entrepreneurship support, and financial literacy training — fostering financial independence and leadership within rural communities."
    },
    "water_sanitation": {
        title: "Water & Sanitation",
        color: "#00ACC1",
        image: "/drinking_water.png",
        description: "As a Key Resource Center (KRC) under the National Jal Jeevan Mission, PSGS drives water efficiency, village sanitation planning, JJM training for Gram Panchayats, school sanitation support, and composting awareness across Maharashtra."
    },
    "sustainable_agriculture": {
        title: "Sustainable Agriculture",
        color: "#43A047",
        image: "/agriculture.jpg",
        description: "PSGS promotes organic farming practices, crop diversification, soil health management, farm-based livelihoods, and watershed development — building climate-resilient farming communities across rural Maharashtra."
    },
    "environment_sustainability": {
        title: "Environment Sustainability",
        color: "#2E7D32",
        image: "/Harmonious_Coexistence.png",
        description: "PSGS advances ecological conservation through social forestry campaigns, waste management drives, biodiversity registers, eco-entrepreneurships, and wildlife conflict mitigation — safeguarding biodiversity while enhancing livelihoods."
    }
};

export const projectList = {
    "womens_empowerment": [
        {
            "id": "women_empowerment_program_2015_2018",
            "name": "Women Empowerment Program",
            "duration": "2015 To 2018",
            "image": "/women-edu.png",
            "brief": "Empowered below-poverty-line women by forming 238 Self-Help Groups (SHGs) under Swarnajayanti Gram Swarojgar Yojana, fostering financial inclusion through bank linkages and enabling sustainable, microfinance-driven livelihoods."
        },
        {
            "id": "shg_formation_2008_2011",
            "name": "SHG Formation under Swarnajayanti Gram Swarojgar Yojana",
            "duration": "2008 To 2011",
            "image": "/women-edu-2.png",
            "brief": "Formed and strengthened over 400 Self-Help Groups enabling 10,000+ women to access microfinance, entrepreneurship, and skill-based livelihoods in Kadegaon taluka."
        },
        {
            "id": "vocational_training_2017_2021",
            "name": "Vocational Training for Women — Tailoring, Jewelry, Dairy",
            "duration": "2017 To 2021",
            "image": "/women-development.jpg",
            "brief": "Delivered vocational trainings in tailoring, jewelry making, and dairy production across 100+ villages, linking 200 SHGs to microfinance and enterprise opportunities."
        }
    ],
    "water_sanitation": [
        {
            "id": "jjm_krc_2017_2021",
            "name": "Jal Jeevan Mission — Key Resource Center (KRC)",
            "duration": "2017 To 2021",
            "image": "/drinking_water.png",
            "brief": "Spearheaded state-level education and communication initiatives across Maharashtra and Goa, implemented village action plans in 56 Kadegaon villages, and championed efficient water use through drip irrigation and conservation campaigns in 131 Sangli villages."
        },
        {
            "id": "jjm_phase3_4_2022_2025",
            "name": "Jal Jeevan Mission — Phases 3–4",
            "duration": "2022 To 2025",
            "image": "/background2.png",
            "brief": "Demonstrated continued leadership by facilitating community-led water monitoring, capacity building, and source sustainability planning in over 40 villages, ensuring long-term water security and resilience."
        },
        {
            "id": "swachhta_abhiyan_2006_2007",
            "name": "Swachhta Abhiyan — Clean Gram Panchayats",
            "duration": "2006 To 2008",
            "image": "/rural.jpg",
            "brief": "Transformed villages like Kadepur, Kadegaon, and Ramapur into 'Clean Gram Panchayats' under Swachhata Abhiyan and Nirmal Gram Yojana by mobilizing communities for toilet construction."
        },
        {
            "id": "sbm_rural_phase1_2015_2019",
            "name": "Swachh Bharat Mission (Rural) Phase-1",
            "duration": "2015 To 2019",
            "image": "/background1.png",
            "brief": "Implemented rural sanitation programs under Swachh Bharat Mission to eliminate open defecation and foster a culture of hygiene across rural Maharashtra."
        },
        {
            "id": "sbm_rural_phase2_2021_ongoing",
            "name": "Swachh Bharat Mission (Rural) Phase-2",
            "duration": "2021 To Ongoing",
            "image": "/background1.png",
            "brief": "Continuing sanitation and hygiene promotion under Phase-2, preparing DPRs for solid waste and sanitation management in target villages."
        },
        {
            "id": "water_conservation_initiative_2010_2015",
            "name": "Water Conservation Initiative",
            "duration": "2010 To 2015",
            "image": "/drinking_water.png",
            "brief": "Enhanced groundwater sustainability through detailed DPRs in 33 villages across Latur, Osmanabad, and Sangli districts, strengthening drinking water sources for approximately 35 villages."
        },
        {
            "id": "nirmal_gram_yojana_2007_2008",
            "name": "Nirmal Gram Yojana",
            "duration": "2007 To 2008",
            "image": "/rural.jpg",
            "brief": "Mobilized communities under Nirmal Gram Yojana to achieve open-defecation-free status, preparing DPRs for sanitation management in target villages."
        }
    ],
    "sustainable_agriculture": [
        {
            "id": "iwmp_2014_2018",
            "name": "Integrated Watershed Management Program (IWMP)",
            "duration": "2010 To 2016",
            "image": "/agriculture.jpg",
            "brief": "Served as Project Implementation Agency for IWMP across 50+ villages in Sangli, Kolhapur, and Satara districts, enhancing soil and water conservation while training SHGs in agro-based livelihoods impacting over 70 villages."
        },
        {
            "id": "organic_farming_promotion_2013_2017",
            "name": "Organic Farming Promotion",
            "duration": "2013 To 2017",
            "image": "/agriculture.jpg",
            "brief": "Conducted organic fertilizer workshops, distributed native tree saplings for social forestry, and led waste management and composting awareness campaigns under Rashtriya Paryavaran Mohim."
        },
        {
            "id": "macp_2017_2025",
            "name": "Maharashtra Agriculture Competitiveness Project",
            "duration": "2017 To 2025",
            "image": "/background1.png",
            "brief": "Strengthened farmer groups under MACP, promoting large-scale afforestation in Tasgaon and advancing crop diversification in salinity-affected zones."
        },
        {
            "id": "crop_diversification_palus",
            "name": "Crop Diversification in Salinity-Affected Zones — Palus",
            "duration": "2017 To 2025",
            "image": "/agriculture.jpg",
            "brief": "Advanced crop diversification in the salinity-affected zones of Palus, enhancing climate-resilient agriculture and safeguarding farmer livelihoods."
        }
    ],
    "environment_sustainability": [
        {
            "id": "biodiversity_registers_2016_2025",
            "name": "Public Biodiversity Registers — 270+ Villages",
            "duration": "2016 To 2025",
            "image": "/Harmonious_Coexistence.png",
            "brief": "Completed public biodiversity registers for over 270 villages in Sangli and Solapur, strengthening local ecosystem governance by establishing biodiversity committees across multiple talukas."
        },
        {
            "id": "leaf_plate_sindhudurg",
            "name": "Biodegradable Leaf Plate Initiative — Sindhudurg",
            "duration": "2022 To 2025",
            "image": "/Empowering_Rural_Communities.png",
            "brief": "Conducted CSR-funded trainings on biodegradable leaf-plate production in 77 Sindhudurg villages, fostering eco-conscious entrepreneurship and reducing plastic waste."
        },
        {
            "id": "hwc_mitigation_sindhudurg",
            "name": "Human–Wildlife Conflict Mitigation — Sindhudurg",
            "duration": "2022 To 2025",
            "image": "/Harmonious_Coexistence.png",
            "brief": "Implemented community-based measures to mitigate human–wildlife conflict in 10 villages, promoting sustainable coexistence through bio-fencing, rapid response teams, and livelihood diversification."
        },
        {
            "id": "rpm_2008_2014",
            "name": "Rashtriya Paryavaran Mohim",
            "duration": "2008 To 2014",
            "image": "/background1.png",
            "brief": "Led waste management and composting awareness campaigns, distributed native tree saplings for social forestry across Kadegaon villages."
        },
        {
            "id": "environment_awareness_campaign_2010_2012",
            "name": "Environment Awareness Campaign",
            "duration": "2010 To 2012",
            "image": "/background2.png",
            "brief": "Organized environment awareness campaigns promoting sustainable practices, waste management, and ecological conservation in rural communities."
        }
    ]
}
